import FingoMuiGrid from '../../fingo/components/MuiGrid';
import INVOICE_UPLOAD_DROPZONE_CLASS_NAME from '../../constants/upload-dropzone';

const invoiceUploadDropzone = ({ theme }) => ({
  boxSizing: 'border-box',
  width: '100%',
  maxWidth: 663,
  minHeight: 118,
  height: 'auto',
  flexDirection: 'column',
  py: 3,
  borderWidth: 2,
  borderStyle: 'dashed',
  borderColor: theme.palette.secondary.main,
  borderRadius: '12px',
  backgroundColor: 'transparent',
});

const MuiGrid = {
  ...FingoMuiGrid,
  styleOverrides: {
    ...FingoMuiGrid.styleOverrides,
    root: ({ theme }) => ({
      ...FingoMuiGrid.styleOverrides.root({ theme }),
      [`&.${INVOICE_UPLOAD_DROPZONE_CLASS_NAME}`]: invoiceUploadDropzone({ theme }),
    }),
  },
};

export default MuiGrid;
